export default __webpack_public_path__ + "static/media/postgreslogo.7b8b45ef.png";